import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const Header = props => {
    const {
        title = null,
        logoUrl = null,
        tenantName = null
    } = props;



    return (
        <header>
            <div className="ac-page">
                {logoUrl ? <img src={logoUrl} className="ac-tenant-logo" alt={tenantName || 'logo'} /> : tenantName || ''}
                <h1 className="ac-collection-title">{title}</h1>
            </div>
        </header>
    );
};

Header.propTypes = {
    title: PropTypes.string,
    logoUrl: PropTypes.string,
    tenantName: PropTypes.string
};

function mapStateToProps(state) {
    let props = {
        title: '',
        logoUrl: null
    }
    const meta = state.meta;

    props.tenantName = "Apt Crowd, LLC.";
    props.logoUrl = "/resource/t/_common/ac-logo.png";

    if (meta) {
        if (meta.friendlyName) {
            props.title = state.meta.collectionName;
        }

        if (meta.tenant) {
            props.logoUrl = meta.tenant.logoUrl;
            props.tenantName = meta.tenant.name;
        }
    }

    return props;
}

export default connect(mapStateToProps)(Header);